// DD-MM-YYYY formatting everywhere
export function formatDate(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function gbp(value, decimals = 2) {
  const n = Number(value || 0);
  return "£" + n.toLocaleString("en-GB", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

export function num(value, decimals = 0) {
  const n = Number(value || 0);
  return n.toLocaleString("en-GB", { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
}

// Accounting style: negatives shown as (£1,234) instead of £-1,234
export function gbpParen(value, decimals = 2) {
  const n = Number(value || 0);
  if (n < 0) return "(" + gbp(Math.abs(n), decimals) + ")";
  return gbp(n, decimals);
}
